import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../hooks/useTheme';

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="relative w-14 h-7 rounded-full transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
      style={{
        backgroundColor: theme === 'dark' ? '#334155' : '#bfdbfe'
      }}
      aria-label="Toggle theme"
    >
      <div
        className={`absolute top-0.5 w-6 h-6 rounded-full transition-all duration-300 flex items-center justify-center ${
          theme === 'dark' 
            ? 'left-0.5 bg-slate-700' 
            : 'left-7 bg-yellow-400'
        }`}
      >
        {theme === 'dark' ? (
          <Moon size={14} className="text-blue-300" />
        ) : (
          <Sun size={14} className="text-yellow-700" />
        )}
      </div>
    </button>
  );
};